import React from "react";
import { Doughnut } from "react-chartjs-2";

const options = {
  maintainAspectRatio: true,
  responsive: false,
  cutout: "86%", // Controls the thickness of the donut (e.g., "70%" or a pixel value)
  rotation: -110, // Start angle in degrees (default 0)
  circumference: 220, // Sweep angle in degrees (default 360)
  plugins: {
    legend: {
      display: false,
      position: "top", // "top", "bottom", "left", "right"
      labels: {
        color: "#333",
        font: {
          size: 14,
          weight: "bold",
        },
        padding: 20,
        boxWidth: 20,
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          return `${context.label}`;
        },
        afterLabel: (context) => `${context.parsed}%`,
      },
      enabled: false,
      backgroundColor: "#fff",
      titleColor: "black",
      bodyColor: "black",
      borderColor: "slategrey",
      borderWidth: 1,
      padding: 10,
      cornerRadius: 8,
      displayColors: false, // <-- Add this line to hide color box in tooltip
      // ...other tooltip options...
    },
    // datalabels: { ... } // If using chartjs-plugin-datalabels
  },
  layout: {},

  animation: {
    animateRotate: true,
    animateScale: false,
  },
};

const getBarColor = (percentageCorrect) => {
  const formatColor = (col) => [col, "#eeeeee"];

  if (percentageCorrect > 79) return formatColor("seagreen");
  if (percentageCorrect > 70) return formatColor("green");
  if (percentageCorrect > 40) return formatColor("darkorange");
  return formatColor("firebrick");
};

const Results = ({ totalAnswers, correctAnswers, percentageCorrect }) => {
  const numIncorrect = totalAnswers - correctAnswers;

  const chartData = {
    labels: ["Correct Answers", "Incorrect Answers"],
    datasets: [
      {
        data: [percentageCorrect, 100 - percentageCorrect],
        borderRadius: 8,
        borderWidth: 0,
        barPercentage: 0.7,
        backgroundColor: getBarColor(percentageCorrect),
        borderColor: "#000",
        spacing: 3,
        offset: 2,
        hoverOffset: 2,
      },
    ],
  };

  return (
    <>
      <span style={{ fontWeight: "500" }}>Results</span>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
        }}
      >
        <Doughnut options={options} data={chartData} width={160} height={160} />
        <div
          style={{
            position: "absolute",
            top: 66,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <span style={{ fontSize: 24, fontWeight: 700 }}>
            {percentageCorrect || 0}%
          </span>
          <span style={{ fontSize: 12 }}>Correct Answers</span>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 16,
          position: "relative",
          top: -6,
        }}
      >
        <span
          style={{ color: "slategrey", fontSize: 13, whiteSpace: "nowrap" }}
        >
          <b style={{ color: "seagreen", fontSize: 14 }}>
            {correctAnswers || 0}
          </b>{" "}
          Correct
        </span>
        <span
          style={{ color: "slategrey", fontSize: 13, whiteSpace: "nowrap" }}
        >
          <b style={{ color: "firebrick", fontSize: 14 }}>
            {numIncorrect || 0}
          </b>{" "}
          Incorrect
        </span>
        <span
          style={{ color: "slategrey", fontSize: 13, whiteSpace: "nowrap" }}
        >
          <b style={{ color: "black", fontSize: 14 }}>{totalAnswers || 0}</b>{" "}
          Total Answers
        </span>
      </div>
    </>
  );
};

export default Results;
